import isEmpty from 'lodash/isEmpty';
import { getAutoApiEndpoints } from '../../enums/apiEndpoints';
import { getIsOfferingType } from '../getIsOfferingType';
import { ComponentApi } from './componentApi';
import { CouponsApi } from './couponsApi';
import { DiscountsApi } from './discountsApi';
import { PagesApi } from './pagesApi';
export const getIsPending = date => !!(date && Number(date) > Date.now());
export const getIsExpired = date => !!(date && Number(date) < Date.now());
export const getStatusByDate = campaign => {
  const _campaign$data = campaign.data,
    campaignDateEnd = _campaign$data.campaignDateEnd,
    campaignDateStart = _campaign$data.campaignDateStart;
  const isExpired = getIsExpired(campaignDateEnd);
  const isPending = getIsPending(campaignDateStart);

  // return isPending ? 'pending' : isExpired ? 'expired' : campaignStatus;
  return isPending ? 'pending' : isExpired ? 'expired' : 'active';
};
export const isCampaignTimeValid = campaign => {
  const isExpired = getIsExpired(campaign.data.campaignDateEnd);
  const isPending = getIsPending(campaign.data.campaignDateStart);
  return !isExpired && !isPending;
};
export async function updateDataItemOffering(_ref) {
  let dataItems = _ref.dataItems,
    updateDataItem = _ref.updateDataItem,
    instance = _ref.instance,
    httpClient = _ref.httpClient,
    flowAPI = _ref.flowAPI;
  const _getAutoApiEndpoints = getAutoApiEndpoints(flowAPI),
    Apis = _getAutoApiEndpoints.Apis;
  const updatedDataItems = await Promise.all(dataItems.map(async dataItem => {
    if (dataItem.campaignStatus === 'archived') {
      return dataItem;
    }
    if (dataItem.offeringId === '') {
      return dataItem;
    }
    const _getIsOfferingType = getIsOfferingType(dataItem.offeringType),
      isCoupon = _getIsOfferingType.isCoupon,
      isAutomaticDiscount = _getIsOfferingType.isAutomaticDiscount,
      isSitePage = _getIsOfferingType.isSitePage;
    if (!isCoupon && !isAutomaticDiscount && !isSitePage) {
      return dataItem;
    }
    const api = getApiByOfferingType([isCoupon, isAutomaticDiscount, isSitePage], Apis);
    function getApiByOfferingType(conditions, Apis) {
      const apiCalls = [() => CouponsApi(instance, httpClient).getCoupon(dataItem.offeringId, Apis), () => DiscountsApi(instance, httpClient).queryDiscount(dataItem.offeringId, Apis), () => PagesApi(httpClient).getSiteStructureRow()];
      return apiCalls[conditions.indexOf(true)];
    }
    return api().then(async response => {
      if (isAutomaticDiscount) {
        const discount = response;
        if (isEmpty(discount)) {
          const updatedDataItem = {
            ...dataItem,
            offeringId: '',
            offeringData: {},
            campaignStatus: 'incomplete',
            offeringDeletedError: 'discounts'
          };
          await updateDataItem(updatedDataItem);
          return updatedDataItem;
        } else {
          return dataItem;
        }
      } else if (isSitePage) {
        const siteMap = response;
        const item = (siteMap.results || []).find(page => page.itemId === (dataItem.offeringItemId ? dataItem.offeringItemId : dataItem.offeringId));
        if (isEmpty(siteMap.results) && !item) {
          const updatedDataItem = {
            ...dataItem,
            offeringId: '',
            offeringPageId: '',
            offeringItemId: '',
            offeringPageUrl: '',
            offeringItemUrl: '',
            campaignStatus: 'incomplete',
            offeringDeletedError: 'site_page'
          };
          await updateDataItem(updatedDataItem);
          return updatedDataItem;
        } else {
          return dataItem;
        }
      } else if (isCoupon) {
        const coupon = response;
        console.log(coupon, isEmpty(coupon));
        if (isEmpty(coupon)) {
          const updatedDataItem = {
            ...dataItem,
            offeringId: '',
            offeringData: {},
            campaignStatus: 'incomplete',
            offeringDeletedError: 'coupons'
          };
          await updateDataItem(updatedDataItem);
          return updatedDataItem;
        } else {
          return dataItem;
        }
      } else {
        return dataItem;
      }
    }).catch(e => {
      console.log(e.message);
      return dataItem;
    });
  }));
  return updatedDataItems;
}
export async function updateDataItemStatus(_ref2) {
  let dataItems = _ref2.dataItems,
    updateDataItem = _ref2.updateDataItem;
  const updatedDataItems = await Promise.all(dataItems.map(async dataItem => {
    if (dataItem.campaignStatus === 'archived') {
      return dataItem;
    }
    const isNoEnd = dataItem.campaignDateEnd === '';
    const isPending = getIsPending(dataItem.campaignDateStart);
    const isExpired = getIsExpired(dataItem.campaignDateEnd);
    if (isNoEnd && !isPending) {
      return dataItem;
    }
    let updatedCampaignStatus = dataItem.campaignStatus;

    // if (isPending) {
    //   updatedCampaignStatus = 'pending';
    // } else
    // else if (!isPending && dataItem.campaignStatus === 'pending') {
    //   updatedCampaignStatus = 'draft';
    // }
    if (isExpired) {
      updatedCampaignStatus = 'expired';
    } else if (!isExpired && dataItem.campaignStatus === 'expired') {
      updatedCampaignStatus = 'draft';
    }
    if (updatedCampaignStatus !== dataItem.campaignStatus) {
      const updatedDataItem = {
        ...dataItem,
        campaignStatus: updatedCampaignStatus
      };
      await updateDataItem(updatedDataItem);
      return updatedDataItem;
    }
    return dataItem;
  }));
  return updatedDataItems;
}
export async function updateDataItemPromoSlot(_ref3) {
  let dataItems = _ref3.dataItems,
    updateDataItem = _ref3.updateDataItem,
    httpClient = _ref3.httpClient;
  const componentApi = ComponentApi(httpClient);
  const updatedDataItems = await Promise.all(dataItems.map(async dataItem => {
    var _dataItem$promoSlot, _components$metadata, _components$component, _components$component2;
    if (dataItem.campaignStatus === 'archived' || !((_dataItem$promoSlot = dataItem.promoSlot) != null && (_dataItem$promoSlot = _dataItem$promoSlot.component) != null && _dataItem$promoSlot.pageId) || !dataItem.promoSlot.id) {
      return dataItem;
    }
    const components = await componentApi.queryComponentById(dataItem.promoSlot.component.pageId, dataItem.promoSlot.id);
    if (((_components$metadata = components.metadata) == null ? void 0 : _components$metadata.count) === 0 && (_components$component = components.components) != null && (_components$component = _components$component.at(0)) != null && (_components$component = _components$component.compFeatures) != null && (_components$component = _components$component.refComponent) != null && (_components$component = _components$component.data) != null && (_components$component = _components$component.widgetRef) != null && _components$component.name) {
      return dataItem;
    }
    const updatedDataItem = {
      ...dataItem,
      promoSlot: {
        ...dataItem.promoSlot,
        widgetName: ((_components$component2 = components.components) == null || (_components$component2 = _components$component2.at(0)) == null || (_components$component2 = _components$component2.compFeatures) == null || (_components$component2 = _components$component2.refComponent) == null || (_components$component2 = _components$component2.data) == null || (_components$component2 = _components$component2.widgetRef) == null ? void 0 : _components$component2.name) ?? dataItem.promoSlot.widgetName
      }
    };
    await updateDataItem(updatedDataItem);
    return updatedDataItem;
  }));
  return updatedDataItems;
}
//# sourceMappingURL=ambassadorDataItemUtils.js.map